import React, { useEffect, useState } from 'react';
import Container from '@/components/container';
import { Form, Button, List, Select, Divider, Col, Row } from 'antd';
import ComponentLog from '@/components/component-log';
import apis from '../apis';
import RangePicker from '@/form-component/range-picker';
import SelectSort from './components/resource-sort';
import './index.less';
import { remainingDay } from '@/common/utils';
import { useHistory } from 'react-router-dom';
// import ConditionIndex from '@/components/condition-index'

const { Option } = Select;
const ResourceSquare = () => {
  const history = useHistory();
  const initParam = {
    outActivityId: undefined,
    minApplyBeginTime: undefined,
    maxApplyEndTime: undefined,
    orderBy: undefined,
    pageSize: 10,
    page: 1,
  };
  const [data, setData] = useState({
    items: [],
    loading: false,
    totalCount: 0,
  });
  const [resourceList, setResourceList] = useState([]);
  const [conditions, setConditions] = useState(initParam);
  const [form] = Form.useForm();
  useEffect(() => {
    apis
      .getResourceState()
      .then((res) => {
        if (res && res.ret === '0') {
          const resourceStates = res.data.resourceStates;
          resourceStates.unshift({ resourceName: '全部', resourceStateCode: '' });
          setResourceList(resourceStates);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    setData((data) => ({ ...data, loading: true }));
    apis
      .genericActivityReadServicequeryForList(conditions)
      .then((res) => {
        const {
          ret,
          data: { items, totalCount },
        } = res;
        if (ret === '0') {
          setData({
            items: items,
            loading: false,
            totalCount: totalCount,
          });
        } else {
          setData((data) =>
            Object.assign({}, data, {
              items: [],
              loading: false,
              totalCount: 0,
            })
          );
        }
      })
      .catch((ex) => {
        setData((data) =>
          Object.assign({}, data, {
            items: [],
            loading: false,
            totalCount: 0,
          })
        );
      });
  }, [conditions]);
  // const formItemLayout = {
  //   labelCol: {
  //     span: 12
  //   },
  //   wrapperCol: {
  //     offset: 1
  //   }
  // }
  const onFinish = (values) => {
    const { activityTime, outActivityId } = values;
    let startTime, endTime;
    if (activityTime) {
      startTime = activityTime[0].format('YYYY-MM-DD HH:mm:ss');
      endTime = activityTime[1].format('YYYY-MM-DD HH:mm:ss');
    }
    setConditions((conditions) => ({
      ...conditions,
      outActivityId: outActivityId,
      minApplyBeginTime: startTime,
      maxApplyEndTime: endTime,
    }));
  };
  const formRowLayout = {
    justify: 'flex-start',
    align: 'middle',
    gutter: 16,
  };

  const ListOperateBtn = (props) => {
    const item = props.data;
    const { totalNumber, usedNumber, outActivityId, batchId, applyStatus, applyBeginTime } = item;

    return (
      <div className="resource-square-btn">
        {applyStatus && applyStatus === 1 ? (
          <div>
            <span style={{ color: 'rgba(235, 51, 51, 0.85)', fontSize: '14px', fontWeight: '600' }}>
              {applyBeginTime} 开放申请！
            </span>
            <Button disabled>待开始</Button>
          </div>
        ) : totalNumber && usedNumber && totalNumber === usedNumber ? (
          <Button disabled>已申请</Button>
        ) : applyStatus && applyStatus === 3 ? (
          <Button disabled>已结束</Button>
        ) : (
          <ComponentLog>
            <Button
              clstag="resource_1627030927203|5"
              onClick={() => {
                window.open('/material-manage/resource-square/apply?batchId=' + batchId);
              }}
              type="primary"
            >
              立即申请
            </Button>
          </ComponentLog>
        )}
        {usedNumber && usedNumber > 0 ? (
          <ComponentLog>
            <a
              clstag="resource_1627030927203|6"
              onClick={() => {
                window.open('/material-manage/resource-apply-list?outActivityId=' + outActivityId);
              }}
              style={{ marginTop: '10px' }}
            >
              申请记录
            </a>
          </ComponentLog>
        ) : null}
      </div>
    );
  };
  const ListItem = (props) => {
    const item = props.item;
    return (
      <div>
        <div>{item.name}</div>
        <div className="resource-square-item-time">
          <div style={{ marginRight: '36px' }}>资源ID：{item.outerActivityId}</div>
          <div style={{ marginRight: '50px' }}>
            申请时间：{item.applyBeginTime}至{item.applyEndTime}
          </div>
          <div>发布时间：{item.activityBeginTime}</div>
        </div>
        <div className="resource-square-item-num">
          <div style={{ marginRight: '27px' }}>资源数量：{item.totalNumber}</div>
          <div>当前已报：{item.usedNumber}</div>
        </div>
        {item.deadline ? (
          <div style={{ marginTop: '13px', color: 'rgba(235, 51, 51, 0.85)', fontSize: '14px', fontWeight: '600' }}>
            {remainingDay(item.deadline)}后截止申请
          </div>
        ) : null}
      </div>
    );
  };
  return (
    <>
      <Container>
        <div style={{ paddingTop: '15px' }}>
          <Form form={form} onFinish={onFinish}>
            <Row {...formRowLayout}>
              <Col span={6}>
                <Form.Item name="outActivityId" label="资源位">
                  <Select defaultValue="" allowClear>
                    {resourceList.map((item) => (
                      <Option value={item.resourceStateCode} key={item.resourceStateCode}>
                        {item.resourceName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="活动范围" name="activityTime">
                  <RangePicker className="form-el-full-size" placeholder={['开始时间', '结束时间']} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Row align="middle" justify="end">
                  <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ marginRight: '16px' }}>
                      查询
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button onClick={() => form.resetFields()} type="submit">
                      重置
                    </Button>
                  </Form.Item>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>

      <Container>
        <div style={{ paddingTop: '16px' }}>
          <div className="new-resource-wrapper">
            <div style={{ color: 'color: rgba(0, 0, 0, 0.85)', fontSize: '16px', fontWeight: 'bold' }}>资源广场</div>
            <SelectSort onChange={(val) => setConditions({ ...conditions, orderBy: val })} value={conditions.orderBy} />
          </div>
          <Divider className="new-resource-wrapper-bottom-divider" style={{ marginTop: '20px', marginBottom: '5px' }} />
          <List
            className="new-resource-manage-actlist"
            itemLayout="vertical"
            size="large"
            loading={data.loading}
            dataSource={data.items}
            pagination={{
              showSizeChanger: false,
              current: conditions.currentPage,
              total: data.totalCount,
              pageSize: conditions.pageSize,
              onChange: (toPage) => {
                setConditions({
                  ...conditions,
                  page: toPage,
                });
              },
            }}
            renderItem={(item, index) => (
              <List.Item className="list-item-wrap" key={item.index} extra={<ListOperateBtn data={item} />}>
                <ListItem item={item} />
              </List.Item>
            )}
          />
        </div>
      </Container>
    </>
  );
};

export default ResourceSquare;
